import React, { useCallback } from 'react'
import chroma from "chroma-js"
import { NavLink } from 'react-router-dom'
import { useState, useEffect } from 'react'
import ColorCell from './ColorCell'
import '../styles/ColorSuggestion.css'
import useWindowWidth from '../hooks/useWindowWidth'
import blindMatrix from '../utils/blindnessMatrix'

const ColorSuggestion = ({palette, setPalette, suggest, setSuggest, main, setMain, buttonState, setButtonState}) => {
  const [complementary, setComplementary] = useState([])
  const [analogous, setAnalogous] = useState([])
  const [triadic, setTriadic] = useState([])
  const [tintShade, setTintShade] = useState([])
  const [saturation, setSaturation] = useState([])
  const [savedPalette, setSavedPalette] = useState(JSON.parse(localStorage.getItem("palette")) || [])
  const [compSelect, setCompSelect] = useState([true, false, false, false, false])
  const [analogSelect, setAnalogSelect] = useState([true, false, false, false, false])
  const [triadicSelect, setTriadicSelect] = useState([true, false, false, false, false])
  const [tintSelect, setTintSelect] = useState([true, false, false, false, false])
  const [saturSelect, setSaturSelect] = useState([true, false, false, false, false])
  const width = useWindowWidth()
  const [mainCellStyle, setMainCellStyle] = useState({
    width: "15vw",
    height: "15vh",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textTransform: "uppercase",
    textShadow: "1px 1px 3px rgb(43, 43, 43)"
  })
  const [variantCellStyle, setVariantCellStyle] = useState({
    width: "15vw",
    maxWidth: "155px",
    height: "5vh",
    borderRadius: "10px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textTransform: "uppercase",
    textShadow: "1px 1px 3px rgb(43, 43, 43)"
  })
  const [matrixId, setMatrixId] = useState('normal')
  const [blindType, setBlindType] = useState("normal")
  const [former, setFormer] = useState(main)

  useEffect(() => {
    let base = chroma(main)

    const complementary = base.set("hsl.h", (base.get("hsl.h") + 180) % 360)
    const compVariants = chroma.scale([base, complementary]).mode('lab').colors(6)
    compVariants.shift()
    setComplementary(compVariants)

    const analog1 = base.set("hsl.h", (base.get("hsl.h") + 30) % 360)
    const analog2 = base.set("hsl.h", (base.get("hsl.h") - 30 + 360) % 360)
    const analogVariants = chroma.scale([analog1, analog2]).mode('lab').colors(5)
    setAnalogous(analogVariants)

    const triad1 = base.set("hsl.h", (base.get("hsl.h") + 120) % 360)
    const triad2 = base.set("hsl.h", (base.get("hsl.h") - 120 + 360) % 360)
    const triadVariants = chroma.scale([triad1, triad2]).mode('lab').colors(5)
    setTriadic(triadVariants)

    const tint = base.brighten(1.5)
    const shade = base.darken(1.5)
    const tintShadeVariants = chroma.scale([tint, shade]).mode('lab').colors(5)
    setTintShade(tintShadeVariants)

    const vivid = base.saturate(1.5)
    const muted = base.desaturate(1.5)
    const saturationVariants = chroma.scale([vivid, muted]).mode('lab').colors(5)
    setSaturation(saturationVariants)

    setPalette([compVariants[0], analogVariants[0], triadVariants[0], tintShadeVariants[0], saturationVariants[0]])

  }, [main, setPalette])

  const handleClick = () => {
    if (buttonState === "Save") {
      const newPalette = [main, ...palette]
      let hasPalette = false
      savedPalette.map((colors) => {
        if (colors.every((val, index) => val === newPalette[index])) {
          alert("Saved palette already contains this palette!")
          setButtonState("Clear")
          hasPalette = true
          return colors
        }
        return colors
      })
      if (hasPalette === false) {
        const jointPalette = [...savedPalette, newPalette]
        localStorage.setItem("palette", JSON.stringify(jointPalette))
        setSavedPalette(jointPalette)
        setButtonState("Clear")
      }
    } else if (buttonState === "Clear") {
      setSuggest(false)
      setButtonState("Save")
      setCompSelect([true, false, false, false, false])
      setAnalogSelect([true, false, false, false, false])
      setTriadicSelect([true, false, false, false, false])
      setTintSelect([true, false, false, false, false])
      setSaturSelect([true, false, false, false, false])
    }
  }

  const handleClear = () => {
    setSuggest(false)
    setPalette([])
    setCompSelect([true, false, false, false, false])
    setAnalogSelect([true, false, false, false, false])
    setTriadicSelect([true, false, false, false, false])
    setTintSelect([true, false, false, false, false])
    setSaturSelect([true, false, false, false, false])
  }

  const handleSuggest = useCallback(() => {
    setSuggest(true)
  }, [setSuggest])

  const handleSelected = (e, id) => {
    if (id === "none") {
      return
    }
    if (Number(id) === 0) {
      const newSelect = changeSelect(complementary, compSelect, e)
      setCompSelect(newSelect)
    } else if (Number(id) === 1) {
      const newSelect = changeSelect(analogous, analogSelect, e)
      setAnalogSelect(newSelect)
    } else if (Number(id) === 2) {
      const newSelect = changeSelect(triadic, triadicSelect, e)
      setTriadicSelect(newSelect)
    } else if (Number(id) === 3) {
      const newSelect = changeSelect(tintShade, tintSelect, e)
      setTintSelect(newSelect)
    } else if (Number(id) === 4) {
      const newSelect = changeSelect(saturation, saturSelect, e)
      setSaturSelect(newSelect)
    }
  }
  
  const changeSelect = (colorArr, colorSelect, e) => {
    let compId = 0
    colorArr.forEach((comp, index) => {
      if (comp === e.currentTarget.innerText.toLowerCase()) {
        compId = index
      }
    })
    colorSelect.map((comp, index) => {
      if (index === compId) {
        colorSelect[index] = true
      } else {
        colorSelect[index] = false
      }
      return colorSelect
    })
    return colorSelect
  }
  
  useEffect(() => {
    if (width < 520) {
      if (width < 380) {
        mainCellStyle.width = "15vw"
        mainCellStyle.height = "22vh"
        mainCellStyle.fontSize = "0.8rem"
        setMainCellStyle(mainCellStyle)
        variantCellStyle.fontSize = "0.75rem"
        setVariantCellStyle(variantCellStyle)
      } else {
        mainCellStyle.width = "17vw"
        setMainCellStyle(mainCellStyle)
        variantCellStyle.width = "17vw"
        setVariantCellStyle(variantCellStyle)
      }
    } else {
      mainCellStyle.width = "15vw"
      mainCellStyle.height = "15vh"
      mainCellStyle.fontSize = "1rem"
      setMainCellStyle(mainCellStyle)
      variantCellStyle.width = "15vw"
      variantCellStyle.fontSize = "1rem"
      setVariantCellStyle(variantCellStyle)
    }
  }, [width, mainCellStyle, variantCellStyle])

  const simulateColorBlindness = ([r, g, b], matrix) => {
    r = Number(r)
    g = Number(g)
    b = Number(b)
    return [
      r * matrix[0][0] + g * matrix[0][1] + b * matrix[0][2],
      r * matrix[1][0] + g * matrix[1][1] + b * matrix[1][2],
      r * matrix[2][0] + g * matrix[2][1] + b * matrix[2][2]
    ];
  }

  const handleMatrixId = (e) => {
    const selectIndex = e.target.selectedIndex
    const selectOption = e.target.options[selectIndex]
    const selectedId = selectOption.id
    setMatrixId(selectedId)
  }

  useEffect(() => {
    if (matrixId === "" || matrixId === "normal") {
      setMain(former)
    } else {
      const arrMatrix = blindMatrix[matrixId]
      const rgbMain = hexToRGB(former)
      const newMain = simulateColorBlindness(rgbMain, arrMatrix)
      const hexMain = rgbToHex(newMain)
      setMain(hexMain)
    }
    setButtonState("Save")
    setCompSelect([true, false, false, false, false])
    setAnalogSelect([true, false, false, false, false])
    setTriadicSelect([true, false, false, false, false])
    setTintSelect([true, false, false, false, false])
    setSaturSelect([true, false, false, false, false])
  }, [matrixId, former, setMain, setButtonState])

  const hexToRGB = (hex) => {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    if (r === 0) {
      return ["00", g, b]
    }
    if (g === 0) {
      return [r, "00", b]
    }
    if (b === 0) {
      return [r, g, "00"]
    }
    return [r, g, b];
  }
  
  const rgbToHex = (rgb) => {
    if (rgb.length === 0) {
        rgb = [66, 66, 66]
    }
    let hex = "#"
    for (let i = 0; i < rgb.length; i++) {
        const el = Number(rgb[i]).toFixed(0)
        const numEl = Number(el)
        let subHex = numEl.toString(16).toUpperCase()
        if (subHex === "0") {
        subHex = "00"
        }
        hex += subHex
    }
    return hex
  }
  const date = new Date()

  return (
    <div className='color-suggestion-page'>
        <nav className='color-suggestion-nav'>
          <ul>
            <li>
              <NavLink 
                to='/color-palette' 
                end
                className={({isActive}) => `navlink link ${isActive ? 'active' : ''}`}
              >Generate Palette</NavLink>
            </li>
            <li>
              <NavLink 
                to='/color-palette/saved-palette' 
                end
                className={({isActive}) => `navlink link ${isActive ? 'active' : ''}`}
              >Saved Palettes</NavLink>
            </li>
          </ul>
        </nav>
        <main>
          {!suggest && <section className="pick-main-color">
              <div className="main-color-picker-div">
                  <label htmlFor="main-color">Pick Main Color: </label>
                  <input type="color" name="main-color" id="main-color" className='main-color' onChange={(e) => {
                    setFormer(e.target.value)
                    setMain(e.target.value)}}/>
              </div>
              <div className="show-main" style={{backgroundColor: main}}></div>
              <button onClick={handleSuggest} className='button'>Suggest Palette</button>
          </section>}
          {suggest && <div className="palette-div">
              <div className="display-main-color" style={{backgroundColor: main}}>{main}</div>
              <div className='palette'>{palette.map((variant) => (<ColorCell 
                selected={"no-select"} 
                variant={variant} 
                supCellStyle={mainCellStyle} 
                id='none' 
                key={`${Math.random()}-${variant}`} 
                palette={palette} 
                setPalette={setPalette} 
                setButtonState={setButtonState} 
                handleSelected={handleSelected}/>))}</div>
          </div>}
          {suggest && <section className="show-suggestions">
              <h3>Suggestions</h3>
              <div className="suggestions">
                  <div className="complementary variants">{complementary.map((variant, index) => (
                    <ColorCell 
                      selected={compSelect[index]}
                      variant={variant} 
                      supCellStyle={variantCellStyle} 
                      id='0' 
                      key={`${1 + Math.random()}-${variant}`}
                      palette={palette}
                      setPalette={setPalette}
                      setButtonState={setButtonState}
                      handleSelected={handleSelected}
                    />))}</div>
                  <div className="analogous variants">{analogous.map((variant, index) => (
                    <ColorCell 
                      selected={analogSelect[index]}
                      variant={variant} 
                      supCellStyle={variantCellStyle} 
                      id='1'
                      key={`${2 + Math.random()}-${variant}`}
                      palette={palette}
                      setPalette={setPalette}
                      setButtonState={setButtonState}
                      handleSelected={handleSelected}
                    />))}</div>
                  <div className="triadic variants">{triadic.map((variant, index) => (
                    <ColorCell 
                      selected={triadicSelect[index]}
                      variant={variant} 
                      supCellStyle={variantCellStyle} 
                      id='2' 
                      key={`${3 + Math.random()}-${variant}`}
                      palette={palette}
                      setPalette={setPalette}
                      setButtonState={setButtonState}
                      handleSelected={handleSelected}
                    />))}</div>
                  <div className="tint-shade variants">{tintShade.map((variant, index) => (
                    <ColorCell 
                      selected={tintSelect[index]}
                      variant={variant} 
                      supCellStyle={variantCellStyle} 
                      id='3' 
                      key={`${4 + Math.random()}-${variant}`}
                      palette={palette}
                      setPalette={setPalette}
                      setButtonState={setButtonState}
                      handleSelected={handleSelected}
                    />))}</div>
                  <div className="saturation variants">{saturation.map((variant, index) => (
                    <ColorCell 
                      selected={saturSelect[index]}
                      variant={variant} 
                      supCellStyle={variantCellStyle} 
                      id='4' 
                      key={`${ 5+ Math.random()}-${variant}`}
                      palette={palette}
                      setPalette={setPalette}
                      setButtonState={setButtonState}
                      handleSelected={handleSelected}
                    />))}</div>
              </div>
              <button onClick={handleClick} className='button'>{buttonState} Palette</button>
              {buttonState === "Save" ? <button style={{marginBottom: "1rem"}} className='button' onClick={handleClear}>Clear Palette</button> : ""}
              <section className="simulate-blindness-palette">
                <div className="divider">
                  Simulate Blindness
                </div>
                <select 
                  name="pick-color-blind-palette" 
                  className='pick-blindness-select'
                  id={matrixId} 
                  value={blindType}
                  onChange={(e) => {
                    handleMatrixId(e)
                    setBlindType(e.target.value)
                  }}>
                  <option value="normal">Normal</option>
                  <option value="PROTANOPIA" id='0'>Protanopia - Red Cone Deficiency</option>
                  <option value="DEUTERANOPIA" id='1'>Deuteranopia - Green Cone Deficiency</option>
                  <option value="TRITANOPIA" id='2'>Tritanopia - Blue Cone Deficiency</option>
                  <option value="ACHROMATOPSIA" id='3'>Achromatopsia - Grayscale</option>
                  <option value="PROTANOMALY" id='4'>Protanomaly - Weak Red Cone</option>
                  <option value="DEUTERANOMALY" id='5'>Deuteranomaly - Weak Green Cone</option>
                  <option value="TRITANOMALY" id='6'>Tritanomaly - Weak Blue/Yellow Cone</option>
                  <option value="MONOCHROMACY" id='7'>Monochromacy - Only Blue Functional</option>
                </select>
              </section>
              <footer>Copyright &copy; {date.getFullYear()} CodeTesco</footer>
          </section>}
      </main>
    </div>
  )
}

export default ColorSuggestion